import React, { useEffect, useState } from "react";
import "./application.scss";
import { Button, Col, Divider, Input, Row, Typography, Popconfirm, Grid } from "antd";
import Icon from "../../../components/icon/icon";
import {
  GetApplicationRes,
  NewApplicationReq,
} from "../../../interfaces/application.interface";
import { HandleErrors } from "../../../utils/handleErrors";
import {
  deleteApplicationsService,
  getAllApplicationsService,
  newApplicationService,
} from "../../../services/application.service";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { GetPermissionRes } from "../../../interfaces/role.interface";
import { PermissionCode } from "../../../enum/permission";

const {useBreakpoint} = Grid

export const Application = () => {
  const screens = useBreakpoint()
  const userPermissions = useSelector<RootState, GetPermissionRes[]>(
    (root) => root.user.permissions
  );
  const health = useSelector<RootState, string>(
    (root) => root.app.health
  )


  const [addPackageShow, setAddPakcgeShow] = useState(false);

  const [data, setData] = useState<GetApplicationRes[]>([]);

  const [submitLoading, setSubmitLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [addApp, setAddApp] = useState<NewApplicationReq>({
    name: "",
    package_name: "",
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      if(health === 'license-false'){
        return;
      }
      const res = await getAllApplicationsService({});
      setData(res.data);
    } catch (error) {
      HandleErrors(error);
    }
  };

  const submit = async () => {
    try {

      if(!addApp.name){
        toast.error('نام را وارد کنید')
        return
      }

      if(!addApp.package_name){
        toast.error('اسم پکیج را وارد کنید')
        return

      }
      setSubmitLoading(true);
      const res = await newApplicationService(addApp);
      toast.success("اطلاعات با موفقیت ثبت شد");
      getData();
      setAddPakcgeShow(false);
      setSubmitLoading(false);
      setAddApp({
    name: "",
    package_name: "",
  })
    } catch (error) {
      HandleErrors(error);
      setSubmitLoading(false);
    }
  };

   const deleteApplication = async (data: GetApplicationRes) => {
    try {
      setDeleteLoading(true);
      const res = await deleteApplicationsService({id: data.id});
      toast.success("اپلیکیشن با موفقیت حذف شد");
      getData();
      setDeleteLoading(false);
    } catch (error) {
      HandleErrors(error);
      setDeleteLoading(false);
    }
  };

  return (
    <div className="Application">
      {health == "license-false" && (
        <div
          style={{
            position: "absolute",
            zIndex: "100000",
            width: "100%",
            height: "100%",
            top: 0,
            right: 0,
            backdropFilter: "blur(3px)",
            backgroundColor: "rgba(255, 255, 255, 0.5)" /* optional tint */,
          }}
        ></div>
      )}
      <Row align={"middle"} justify={"space-between"} className="title-box">
        <Col>
          <Typography.Text className="title">مدیریت اپلیکیشن</Typography.Text>
        </Col>
        <Col md={4} xs={10}>
          {userPermissions.find(p => p.code === PermissionCode.createApplication) && <div
            className="btn-box"
            onClick={() => {
              setAddPakcgeShow(true);
            }}
          >
            <Icon src="/assets/icons/Add - Circle.svg" />
            <Typography.Text className="title">افزودن اپلیکیشن </Typography.Text>
          </div>}
        </Col>
      </Row>
      <div className="info-box">
        <Row>
          <Col>
            <Typography.Text className="title">
              لیست اپلیکیشن‌ها
            </Typography.Text>
          </Col>
        </Row>
        <Divider />
        {addPackageShow && (
          <div className="add-app-box">
            <Row justify={"space-between"} align={"top"} className="sec1">
              <Col md={10}  xs={24}  className="input-box">
                <Typography.Text className="title"><span style={{color: 'red'}}>*</span>نام: </Typography.Text>
                <Input
                  size="large"
                  variant="filled"
                  className="input"
                  value={addApp.name}
                  onChange={(e) => {
                    setAddApp({
                      ...addApp,
                      name: e.target.value,
                    });
                  }}
                />
              </Col>
              {screens.md && <Col>
                <Icon src="/assets/icons/Totp.svg" />
              </Col>}
            </Row>
            <Row justify={"space-between"} className="sec2">
              <Col md={18} xs={24} className="input-box">
                <Input
                  value={addApp.package_name}
                  onChange={(e) => {
                    setAddApp({
                      ...addApp,
                      package_name: e.target.value,
                    });
                  }}
                  className="input"
                  size="large"
                  placeholder="*نام پکیج اپلیکیشن را وارد کنید"
                  variant="filled"
                />
              </Col>
              <Col md={3} xs={11} style={{marginTop: screens.md ? 0 : 10}}>
                <Button
                  loading={submitLoading}
                  onClick={submit}
                  size="large"
                  type="primary"
                  block
                >
                  تایید
                </Button>
              </Col>
              <Col md={2} xs={11} style={{marginTop: screens.md ? 0 : 10}}>
                <Button
                  loading={submitLoading}
                  className="cancel-add-app-btn"
                  onClick={()=>{
                    setAddPakcgeShow(false);
                    setAddApp({
                      name: "",
                      package_name: "",
                    })
                  }}
                  size="large"
                  type="primary"
                  block
                >
                  لغو
                </Button>
              </Col>
            </Row>
            <Divider />
          </div>
        )}

        {data.map((item) => {
          return (
            <div className="data-box">
              <Row justify={'space-between'}>
                <Col xs={5} md={1} className="icon-box">
                  <Icon src="/assets/icons/Tick - Circle 2.svg" />
                </Col>
                <Col xs={17} md={6} >
                  <Typography.Text className="name">
                    {item.name}
                  </Typography.Text>
                </Col>
                <Col md={{span: 1, offset:15}} xs={4}>
                  <Popconfirm
                      title={`حذف اپلیکیشن: ${item.name}`}
                      description="اپلیکیشن شده قابل بازیابی نیست، مطمئن هستید؟"
                      onConfirm={()=>{
                        deleteApplication(item)
                      }}
                      onCancel={()=>{

                      }}
                      okText="حذف شود"
                      cancelText="لغو"
                    >
                      <Button
                        type="text"
                        loading={deleteLoading}
                      >
                        <i className="las la-trash delete-icon"></i>
                      </Button>
                  </Popconfirm>
                </Col>
              </Row>
              <Row >
                <Col md={3} xs={24}>
                  <Typography.Text className="package">
                    {item.package_name}
                  </Typography.Text>
                </Col>
                <Col md={1} xs={24} >
                  <Divider type="vertical" />
                </Col>
                <Col style={{ direction: "ltr" }}>
                  <Typography.Text className="token-title">
                    API Token:{" "}
                  </Typography.Text>
                  <Typography.Text className="token">
                    {item.public_key}{" "}
                  </Typography.Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>
    </div>
  );
};
